enum ServiceComponentType {
  CHECK_UNIFI_EQUIPMENT = "CHECK_UNIFI_EQUIPMENT",
  REBOOT_EQUIPMENT = "REBOOT_EQUIPMENT",
  CHOOSE_INTERNET_CONFIGURATION = "CHOOSE_INTERNET_CONFIGURATION",
  END_CONNECTION = "END_CONNECTION",
  LIVE_CHAT = "LIVE_CHAT",
  WE_ARE_SORRY = "WE_ARE_SORRY",
  SPEEDTEST_CHOICE = "SPEEDTEST_CHOICE",
  SPEED_TEST = "SPEED_TEST",
  ASK_SPEED_TEST = "ASK_SPEED_TEST",
  GOOD_RESULT = "GOOD_RESULT",
  BAD_RESULT = "BAD_RESULT",
  ROUTER_WIFI_ENABLED = "ROUTER_WIFI_ENABLED",
  WIFI_ENABLED = "WIFI_ENABLED",
  WIFI_DISABLED = "WIFI_DISABLED",
  MESH_ROUTER_NOT_WORKING = "MESH_ROUTER_NOT_WORKING",
  CHECK_POWERLED_LIGHT = "CHECK_POWERLED_LIGHT",
  CHECK_POWER_SOCKET = "CHECK_POWER_SOCKET",
  CREATE_REPORT = "CREATE_REPORT",
  REPORT_CREATED = "REPORT_CREATED",
}

export { ServiceComponentType }
